import React from "react";
import { createScope, partnerCenterTheme } from "@harmony/enablers/react";
import {
  dataGrid,
  commandBar,
  button,
  icon,
  searchBox,
  flyInPanel,
  textField,
  toggle,
  menu,
  menuItem,
  dropdown,
  filterPill,
  buttonGroup,
  visuallyHidden,
  breadcrumb,
  breadcrumbItem
} from '@harmony/enablers/react';

const scope = createScope({
    basePath: "https://harmonyenablers.microsoft.com/npm/@harmony/enablers/6.34.1",
  reactInstance: React,
  styles: [partnerCenterTheme]
});

export const DataGrid = scope.forReact(dataGrid);
export const CommandBar = scope.forReact(commandBar);
export const Button = scope.forReact(button);
export const Icon = scope.forReact(icon);
export const SearchBox = scope.forReact(searchBox);
export const FlyInPanel = scope.forReact(flyInPanel)
export const TextField = scope.forReact(textField);
export const Toggle = scope.forReact(toggle);
export const Menu = scope.forReact(menu);
export const MenuItem = scope.forReact(menuItem);
export const Dropdown = scope.forReact(dropdown);
export const FilterPill = scope.forReact(filterPill);
export const ButtonGroup = scope.forReact(buttonGroup);
export const VisuallyHidden = scope.forReact(visuallyHidden);
export const Breadcrumb = scope.forReact(breadcrumb);
export const BreadcrumbItem = scope.forReact(breadcrumbItem);